export const createModal = ({ tag, html }: { tag: string; html: string }) => {
  const modal = document.createElement(tag);
  modal.innerHTML = html;
  document.body.appendChild(modal);
};

export const createContentModal = (html: string) => {
  createModal({
    tag: 'a-content-modal',
    html,
  });
};

export const createImageModal = (html: string) => {
  createModal({
    tag: 'a-image-modal',
    html,
  });
};
